import { IPayloadDelete } from '~/utils/interface/customer';
import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';
import { IEquipment, IParamsGetEquipment, IResponseGetEquipment } from '~/utils/interface/equipment';

const url = `api/admin/equipments`;

const equipmentApi = {
  create(data: IEquipment) {
    return axiosClient.post<IApiBaseResponse<IEquipment>>(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
  getList(params: IParamsGetEquipment) {
    return axiosClient.get<IApiBaseResponse<IResponseGetEquipment>>(`api/admin/equipments`, { params });
  },
  getDetail(id: string) {
    return axiosClient.get<IApiBaseResponse<IEquipment>>(`api/admin/equipments/${id}`);
  },
  delete(data: IPayloadDelete) {
    return axiosClient.delete<IApiBaseResponse<null>>(url, { data });
  },
  update(id: string | undefined, data: IEquipment) {
    return axiosClient.put<IApiBaseResponse<IEquipment>>(`api/admin/equipments/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export default equipmentApi;
